export default {
    screenWMS: {
        detail: '订单详情',
        log: '扫描日志',
        printPickQty: '已拣货数量',
        printPickTotal: '总数量',
        customer: '客户',
        type: '类型',
        Condition: '值',
        Created: '创建人',
        Enter: '输入地址关键字(使用;分割)',
        printPick: '打印拣货单',
        waveId: '波次编号',
        Status: '状态',
        completion: '完成时间',
        orderCount: '订单数量',
        orderID: '订单编号',
        sortingStation: '分拣台',
        Creator: '创建人',
        creation: '创建时间',
        wmsID: 'WMS 编号',
        pick: '拣货数量',
        sort: '分拣数量',
        total: '订单商品总数',
        basket: '篮子编号',
        SKU: 'SKU',
        order: '订单',
        scan: '扫描时间',
        sortingTime: '分拣时间',
        history: '历史',
        Print: '打印',
        PrintAll: '打印全部',
        Skip: '跳过',
        unSkip: '不跳',
        close: '关单',
        shelves: '货架数',
        address: '大屏地址',
        Printer: '打印机信息',
        allHis: '全历史记录',
        basketS: '篮子编号(起)',
        basketE: '篮子编号(止)',
        orderHis: '订单历史记录',
        lampConfig: '灯架配置',
        lamp: '灯架编号',
        Equipment: '设备编号',
        ps1: '篮子编号【开始值】需要小于【结束值】',
        ps2: '地址格式错误',
        ps3: '已获取文件信息，正在打印，请稍后！',
        ps4: '无可打印数据，打印失败！',
        ps5: '波次编号不能为空',
    }
};
